import{installIOSReleaseNavigationGuard}from'./ios-release-contract.mjs';

installIOSReleaseNavigationGuard();
await import('./main.jsx');
